<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.back()"></div>
      <div class="big_tit">{{$t('financial.name')}}</div>
      <div class="detail font-14 color-white" @click="$router.push('/financial_record')">{{$t('Detail')}}</div>
    </div>

    <section class="page-main">
      <div class="page">
        <div class="interest-wrap">
          <ul style="background: #fff;border-radius: 6px;">
            <li>
              <div class="interest-wrap-value">
                <p style="color: #999;">{{$t('financial.account_balance')}} </p>
                <span>{{ubalance}}</span>
              </div>
<!--              <div class="interest-wrap-value" @click="$router.push('/recharge')">-->
<!--                <p style="color: #999;">-->
<!--                </p>-->
<!--                <span>{{ $t("user.recharge") }}</span>-->
<!--              </div>-->
              <div class="interest-wrap-value">
                <p style="color: #999;">{{$t('financial.financial_assets')}}</p>
                <span>{{balance}}</span>
              </div>
            </li>
          </ul>
          <div class="ui-btn" style="margin-top: 20px;margin-bottom: 20px;" @click="$router.push('/cash?method=1')">
            {{$t('moneybag.withdraw')}}
          </div>
        </div>
        <div class="ui-form" style="margin-top: 30px">
          <div class="ui-form-item">
            <label>{{$t('financial.deposite_amount')}}</label>
            <input type="text" class="ui-form-input" v-model="price" v-on:input="yjsy"
                   :placeholder="$t('financial.deposit_amount_empty')" autocomplete="off">
          </div>
          <div class="ui-form-item">
            <label>{{$t('financial.expected_revenue')}}</label>
            <input type="text" class="ui-form-input" v-model="revenue" id="revenue" readonly="" disabled="">
          </div>
        </div>

        <div class="product__wrap">
          <div v-for="(item,index) in lixibao" class="sjakeh " :class="lcid == item.id? 'current' : ''"
               @click="yjsy1(item.id)">
            <div class="sjakeh-title-1">{{item.name}}</div>
            <div class="sjakeh-title-2">{{item.bili*100}} %</div>
            <div class="djakew">
              {{$t('financial.regular')}} {{item.day}}&nbsp;{{$t('financial.day')}}
            </div>
          </div>
        </div>
        <div class="ui-btn" style="margin-top: 40px;margin-bottom: 30px;" @click="buy">
          {{$t('financial.get_contract')}}
        </div>

        <div class="tips">
          <p>1: El monto mínimo de firma del contrato es superior a 500 MXN.<br/></p>
          <p>2: Complete un contrato de tesorería completo para eximir la tarifa de retiro del 15%<br/>
          <p>3: La terminación del contrato a mitad de camino no generará ingresos, y la tarifa de retiro se cobrará
            normalmente.<br/></p>
          <p>El Banco de Inglaterra y ROG son conjuntamente responsables del proyecto de tesorería, y ROG tiene el
            derecho final de interpretación.</br></p>
        </div>
      </div>

    </section>


  </div>
</template>

<script>
  import Fetch from "../../utils/fetch";

  export default {
    name: "index",
    data() {
      return {
        lang: this.$i18n.locale || "en_us",
        ubalance: '0.00',
        balance: '0.00',
        lixibao: [],
        lcid: 1,
        price: '',
        revenue: '',
      };
    },
    created() {
      this.$parent.footer('index', false);
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        Fetch('/financial/index').then(r => {
          this.ubalance = r.data.info.ubalance;
          this.balance = r.data.info.balance;
          this.lixibao = r.data.lixibao;
          if (this.lixibao.length > 0) {
            this.lcid = this.lixibao[0].id;
          }
        })
      },
      yjsy1(id) {
        this.lcid = id;
        this.yjsy();
      },
      // 计算收益
      yjsy() {
        if (!this.lcid) {
          return false;
        }
        if (this.price == '') {
          return false;
        }
        if (parseFloat(this.price) <= 0) {
          return false;
        }
        let index = this.lixibao.findIndex(item => item.id == this.lcid);
        let income = parseFloat(this.price) * parseFloat(this.lixibao[index].day) * parseFloat(this.lixibao[index].bili);
        this.revenue = income.toFixed(2);
        // Fetch('/financial/deposityj', {
        //   lcid: this.lcid,
        //   price: this.price,
        // }).then(r => {
        //   this.revenue = r.data;
        // })
      },
      buy() {
        if (this.price == '') {
          this.$notify(this.$t('financial.deposit_amount_empty'));
          return false;
        }
        Fetch('/financial/buyIn', {
          lcid: this.lcid,
          price: this.price,
        }).then(r => {
          console.log(r);
          if (r.code == 1) {
            this.$toast({
              background: '#07c160',
              message: r.info
            });
            setTimeout(() => {
              this.getData();
              this.price = '';
              this.revenue = '';
            }, 2000);
          } else {
            this.$toast({
              background: 'red',
              message: r.info
            });
          }
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  #app {
    background: #f8f8f8 !important;
  }

  .basic_wrap {
    background: #f8f8f8 !important;
  }

  .red_top_bg {
    /*height: 126px;*/
    background: #76b900;
    /*position: fixed;*/
  }

  .page-main {
    padding-bottom: 0;
    /*margin-top: 60px;*/
    position: absolute;
    background: #f8f8f8;
    width: 100%;
  }

  .page {
    margin: 20px;
  }

  .interest-wrap {
    background-color: rgb(255, 255, 255);
    border-radius: 6px;
    height: 180px;
  }

  .interest-wrap li {
    display: flex;
    padding: 16px 0;
  }

  .interest-wrap-value {
    flex: 1;
    text-align: center;
  }

  .interest-wrap-value p {
    font-size: 12px;
    color: #d5f5ff;
    margin-bottom: 0.6rem;
  }

  p {
    margin-top: 0.08rem;
    margin-bottom: 0.08rem;
  }

  .interest-wrap-value span {
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    color: #000;
  }

  .ui-form-item {
    margin-bottom: 24px;
    border-bottom: 1px solid #d6dfff;
    position: relative;
  }

  .ui-form-item label {
    height: 16px;
    margin-right: 20px;
    font-family: Calibri;
    font-size: 14px;
    font-weight: bold;
    color: #999;
  }

  .ui-form-input {
    height: 40px;
    padding: 6px 0;
    outline: unset;
    font-size: 16px;
    color: #a1a1a1;
    background: none;
    outline: none;
  }

  .product__wrap {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .sjakeh {
    width: 48%;
    padding: 16px 0px 16px 20px;
    margin-bottom: 12px;
    border-radius: 5px;
    background-color: #fff;
  }

  .current {
    border: solid 1px #76b900 !important;
  }

  .sjakeh-title-1 {
    font-size: 12px;
    font-weight: bold;
    color: #000;
  }

  .sjakeh-title-2 {
    margin: 8px 0px 8px 0;
    font-size: 20px;
    font-weight: bold;
    color: #76b900;
  }

  .djakew {
    font-size: 13px;
    font-weight: 500;
    color: #c1c1c1;
    background-color: unset;
  }

  .ui-btn {
    border-radius: 23px;
    background-color: #76b900;
    height: 45px;
    line-height: 45px;
    font-weight: bold;
    font-size: 14px;
    text-align: center;
    color: #fff;
  }

  .tips p {
    margin-bottom: 5px;
  }
</style>
